module.exports = __webpack_public_path__ + "files/64896cc40201c98bbf01a4593efd173e.png";